import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Pillar } from '../../../section/section.model';

@Component({
  selector: 'document-group-list-container',
  templateUrl: './group-list-container.component.html',
  styleUrls: ['./group-list-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GroupListContainerComponent implements OnInit {
  @Input() groups: Pillar[];
  @Input() newIndicatorDays: string;

  constructor() {}

  ngOnInit(): void {}
}
